var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whychoose"},[_c('div',{staticClass:"why"},[_c('h2',[_vm._v("为何选择"),_c('span',[_vm._v("儿童手机管理")])])]),_c('div',{staticClass:"why-img"},[_c('img',{attrs:{"src":require("../../assets/pc-box-3-icon.png"),"alt":""}})])])
}]

export { render, staticRenderFns }